import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {},
  jobInfo: {
    backgroundColor: '#fbf5fe',
  },
  infoRow: {
    marginBottom: 5,
    alignItems: 'center',
  },
  label: {
    fontWeight: 700,
    width: 150,
  },
}));
